import { kadhavuExpUrl } from 'endpoints';
import { createStyles } from '../utils/create-styles';
import { startLoading, endLoading } from './app-dux';
import { fetch } from '@nackle/umbrella';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    id: null,
    name: '',
    companyBranding: {
        primaryColor: '',
        primaryLogo: '',
        secondaryColor: '',
        secondaryLogo: ''
    },
    countryList: [],
    defaultLocaleCode: '',
    contactEmailAddress: ''
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_COMPANY = 'SET_COMPANY';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_COMPANY: {
            return {
                ...state,
                ...action.company
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function getCompany( ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return fetch( `${ kadhavuExpUrl }/company`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } )
        .then( ( res ) => {

            if ( res.ok ) {
                return res.json().then( ( data ) => {
                    delete data.success;
                    dispatch( setCompany( data ) );
                    dispatch( endLoading() );
                } );
            } else {
                return res.json().then( ( data ) => {
                    throw new Error( data.errors );
                } );
            }
        } )
        .finally ( () => {
            dispatch( endLoading() );
        } );
    };
}

export function setCompany ( company ) {
    //Create CSS Style Sheet in the DOM
    createStyles( company.companyBranding, 'head' );

	//Create s3 link for CSS in the DOM

    // Commenting this until we implement dynamically creating css links to avoid 403's from aws s3 bucket
    // createTemplateLink( company.id, 'head' );

    return {
        type: SET_COMPANY,
        company
    };
}